export default interface Role {
  id: number | string;
  name: string;
  key: string;
}
